import React from 'react';
import styles from './Confirm.module.scss';
import Button from "../Button";
import {ConfirmPropsInterface} from "./Confirm.props.interface";

const Confirm: React.FC<ConfirmPropsInterface> = (
    {
        type = 'danger',
        direction = 'column',
        children = undefined,
        onCancelText = 'Отменить',
        onSubmitText = 'Продолжить',
        onCancel,
        onSubmit,
        ...rest
    }) => {

    return (
        <div className={[
            styles.container,
            type ? styles[type] : styles.danger,
            styles[direction]
        ].filter(x => x ?? x).join(' ')} {...rest}>
            <div className={styles.message}>
                {children}
            </div>
            <div className={styles.btn}>
                <Button
                    size={'small'}
                    theme={'outline'}
                    onClick={onCancel}
                    type={'tertiary'}>
                    {onCancelText}
                </Button>
                <Button
                    size={'small'}
                    theme={'default'}
                    onClick={onSubmit}
                    type={type}>
                    {onSubmitText}
                </Button>
            </div>
        </div>
    );
};

export default Confirm;
